import type {Checkout} from '@wix/ambassador-checkout/types'
import type {Order} from '@wix/ambassador-ep-orders/types'

export const isFreeCheckout = (checkout: Checkout) => {
  return Number(checkout.priceSummary!.total!.amount) === 0
}

export const isFreeOrder = (order: Order) => {
  return Number(order.priceSummary!.total!.amount) === 0
}
